import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/edit.svg'
import _imports_1 from '@/assets/icons/icon-bucket.svg'
import _imports_2 from '@/assets/icons/arrow-left-eoi-request.svg'


const _hoisted_1 = {
  key: 0,
  class: "spinner"
}
const _hoisted_2 = {
  key: 1,
  class: "customer__container"
}
const _hoisted_3 = { class: "customer__header" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "card" }
const _hoisted_7 = { class: "details-block" }
const _hoisted_8 = { class: "details-row details-row--adaptive" }
const _hoisted_9 = { class: "details-value" }
const _hoisted_10 = { class: "details-row details-row--adaptive" }
const _hoisted_11 = { class: "details-value" }
const _hoisted_12 = { class: "details-row details-row--adaptive" }
const _hoisted_13 = { class: "details-value" }
const _hoisted_14 = { class: "details-row details-row--adaptive" }
const _hoisted_15 = { class: "details-value" }
const _hoisted_16 = { class: "details-row details-row--adaptive" }
const _hoisted_17 = { class: "details-value" }
const _hoisted_18 = { class: "details-block details-block--preferences" }
const _hoisted_19 = { class: "details-row details-row--adaptive" }
const _hoisted_20 = { class: "details-value" }
const _hoisted_21 = { class: "details-row details-row--adaptive" }
const _hoisted_22 = { class: "details-value" }
const _hoisted_23 = { class: "details-row details-row--adaptive" }
const _hoisted_24 = { class: "details-value" }
const _hoisted_25 = { class: "details-row details-row--adaptive" }
const _hoisted_26 = { class: "details-value" }
const _hoisted_27 = { class: "details-row details-row--adaptive" }
const _hoisted_28 = { class: "details-value" }
const _hoisted_29 = { class: "details-row details-row--adaptive" }
const _hoisted_30 = { class: "details-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.isFetching)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    (Object.keys($setup.data).length && !$setup.isFetching)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "wrapper-dots",
            onClick: _withModifiers($setup.onDots, ["stop"])
          }, [
            _createVNode($setup["ActionsComponent"], {
              class: "cursor-pointer",
              "is-active": $setup.showActions,
              onClickOutside: $setup.clickOutside
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "action-default",
                  onClick: $setup.onEdit
                }, [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("img", { src: _imports_0 }, null, -1),
                  _createElementVNode("span", null, "Edit", -1)
                ]))]),
                _createElementVNode("div", {
                  class: "action-default action-default--warning",
                  onClick: $setup.onDelete
                }, [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("img", {
                    class: "warning-icon",
                    src: _imports_1
                  }, null, -1),
                  _createElementVNode("span", null, "Delete", -1)
                ]))])
              ]),
              _: 1
            }, 8, ["is-active"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", {
              class: "customer__title",
              onClick: $setup.onBack
            }, [
              _cache[2] || (_cache[2] = _createElementVNode("img", { src: _imports_2 }, null, -1)),
              _createElementVNode("span", null, _toDisplayString($setup.data.estate.title), 1)
            ]),
            _createElementVNode("button", {
              class: "button map-view-primary",
              onClick: $setup.onEstateCard
            }, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("span", { class: "button-text" }, "Estate map", -1)
            ]))])
          ]),
          _createElementVNode("div", {
            class: "card card--estate",
            onClick: $setup.onEstateCard
          }, [
            _createElementVNode("img", {
              src: $setup.data.estate.logo
            }, null, 8, _hoisted_4),
            _createElementVNode("div", _hoisted_5, _toDisplayString($setup.data.estate.title), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "header" }, "Buyer details", -1)),
              _createElementVNode("div", _hoisted_8, [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "details-label" }, "First name", -1)),
                _createElementVNode("div", _hoisted_9, _toDisplayString($setup.data.buyer.firstName), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "details-label" }, "Last name", -1)),
                _createElementVNode("div", _hoisted_11, _toDisplayString($setup.data.buyer.lastName), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "details-label" }, "Email", -1)),
                _createElementVNode("div", _hoisted_13, _toDisplayString($setup.data.buyer.email), 1)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "details-label" }, "Phone Number", -1)),
                _createElementVNode("div", _hoisted_15, _toDisplayString($setup.data.buyer.phone), 1)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "details-label" }, "Postcode", -1)),
                _createElementVNode("div", _hoisted_17, _toDisplayString($setup.data.buyer.postcode? $setup.data.buyer.postcode
: $setup.data.buyer.state), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "header" }, "Lot preferences", -1)),
              _createElementVNode("div", _hoisted_19, [
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "details-label" }, "Lot size from", -1)),
                _createElementVNode("div", _hoisted_20, _toDisplayString($setup.data.lot.size.from), 1)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "details-label" }, "Lot size to", -1)),
                _createElementVNode("div", _hoisted_22, _toDisplayString($setup.data.lot.size.to), 1)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "details-label" }, "Frontage from", -1)),
                _createElementVNode("div", _hoisted_24, _toDisplayString($setup.data.lot.frontage.from), 1)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "details-label" }, "Frontage to", -1)),
                _createElementVNode("div", _hoisted_26, _toDisplayString($setup.data.lot.frontage.to), 1)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "details-label" }, "Price from", -1)),
                _createElementVNode("div", _hoisted_28, _toDisplayString($setup.data.lot.budget.from), 1)
              ]),
              _createElementVNode("div", _hoisted_29, [
                _cache[15] || (_cache[15] = _createElementVNode("div", { class: "details-label" }, "Price to", -1)),
                _createElementVNode("div", _hoisted_30, _toDisplayString($setup.data.lot.budget.to), 1)
              ])
            ]),
            _createElementVNode("div", { class: "actions" }, [
              _createElementVNode("button", {
                class: "button primary",
                onClick: $setup.onEdit
              }, "Edit"),
              _createElementVNode("div", { class: "leave" }, [
                _cache[17] || (_cache[17] = _createElementVNode("img", {
                  class: "warning-icon",
                  src: _imports_1
                }, null, -1)),
                _createElementVNode("span", { onClick: $setup.onDelete }, "Leave Waitlist")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}